import UserDetailsService from "../component/services/userDetailsService";

class ThemeService {
    private currentTheme: 'light' | 'dark' = 'dark';
    private listeners: Array<(theme: 'light' | 'dark') => void> = [];

    constructor() {
        // Load from browser storage
        const stored = localStorage.getItem('expensecalc_theme');
        if (stored === 'light' || stored === 'dark') {
            this.currentTheme = stored;
            this.applyTheme(stored);
        } else {
            this.applyTheme(this.currentTheme);
        }
    }

    getTheme(): 'light' | 'dark' {
        return this.currentTheme;
    }

    setTheme(theme: 'light' | 'dark', persistToUser: boolean = false) {
        this.currentTheme = theme;
        this.applyTheme(theme);
        localStorage.setItem('expensecalc_theme', theme);
        
        if (persistToUser) {
            // Update user's theme preference in backend
            this.updateUserTheme(theme);
        }
        
        this.notifyListeners();
    }

    subscribe(listener: (theme: 'light' | 'dark') => void) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }

    private notifyListeners() {
        this.listeners.forEach(listener => listener(this.currentTheme));
    }

    private applyTheme(theme: 'light' | 'dark') {
        document.documentElement.setAttribute('data-theme', theme);
    }

    private async updateUserTheme(theme: 'light' | 'dark') {
        const UserDetailsService = (await import('../component/services/userDetailsService')).default;
        await UserDetailsService.updateTheme(
            theme,
            async () => {
                // Theme updated successfully
            },
            async (error: string) => {
                console.error('Failed to update user theme:', error);
            },
            async () => {}
        );
    }

    async syncFromUser() {
        // Load theme from user's profile
        const UserDetailsService = (await import('../component/services/userDetailsService')).default;
        await UserDetailsService.getOwnUserDetails(
            async (user) => {
                if (user.theme && (user.theme === 'light' || user.theme === 'dark')) {
                    this.setTheme(user.theme, false); // Don't persist back to user, just sync
                }
            },
            async () => {
                // User not logged in, use stored theme
            },
            async () => {}
        );
    }

}

const themeService = new ThemeService();
export default themeService;

